import { useQuery } from 'react-query';
import { urlConfig } from 'utils/url-config';

const useGetAdminUsers = (id: string | undefined) => {
	const { isLoading, isError, data, error, refetch } = useQuery('users for admin', async () => {
		const response = await fetch(`${urlConfig.API_URL}${urlConfig.api.adminUsers.replace(':id', id as string)}`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + localStorage.getItem('token'),
			},
		});

		if (!response.ok) {
			throw new Error('Failed to fetch posts');
		}

		return response.json();
	});

	return {
		isLoading,
		isError,
		users: data,
		error,
		refetch,
	};
};

export default useGetAdminUsers;
